<template>
    <div class="page-shelf-manage-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺設置</div>
            <div class="breadcrumb-item">報關品名管理 修改</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Form :label-width="150">
                    <Row>
                        <Col span="11">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>品名</span>
                                </div>
                                <Input v-model="form.name"/>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>HS編碼</span>
                                </div>
                                <Input v-model="form.code"/>
                            </FormItem>
                        </Col>

                        <Col span="11">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>商品貨號</span>
                                </div>
                                <Input v-model="form.number"/>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>拼音</span>
                                </div>
                                <Input v-model="form.pinyin"/>
                            </FormItem>
                        </Col>
                    </Row>

                    <div class="pg-btn-wrap" style="text-align: center;">
                        <div class="pg-btn style1" @click="handleCheckForm">確定</div>
                        <div class="pg-btn" @click="handleBack">返回</div>

                        <!--<Button type="error" :loading="true" class="loading-btn">
                            <span>Loading...</span>
                        </Button>-->
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageParam: {},
                shopList: [],
                form: {
                    name: '', //品名
                    code: '', //HS编码
                    number: '',   //货号
                    pinyin: '',  //规格
                },
                isSubmiting: false,
            };
        },
        mounted()
        {
            this.pageParam = this.$route.query;
            this.getDetail();
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },

            getDetail()
            {
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.customDocDetail + '/' + this.pageParam.id,
                    method: 'get'
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        let resData = res.data;
                        this.form = {
                            id: resData.id,
                            name: resData.name,
                            code: resData.code,
                            number: resData.number,
                            pinyin: resData.pinyin
                        }
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleCheckForm()
            {
                let form = this.form;
                if (form.name === '')
                {
                    this.$Utils.showTipInfo('請輸入品名');
                    return;
                } else if (form.number === '')
                {
                    this.$Utils.showTipInfo('請輸入商品貨號');
                    return;
                } else if (form.code === '')
                {
                    this.$Utils.showTipInfo('請輸入HS編碼');
                    return;
                } else if (form.pinyin === '')
                {
                    this.$Utils.showTipInfo('請輸入拼音');
                    return;
                }

                this.handleSubmit();
            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.customDocUpdate + '/' + this.pageParam.id,
                    method: 'post',
                    data: {
                        name: form.name, 
                        code: form.code,
                        number: form.number,
                        pinyin: form.pinyin,
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "SetCustomDocEdit";
</style>